<div class="main-container">
  <p>
    This configuration has technical errors. Please connect with
    <span (click)="openModal()">Customer support</span>.
  </p>
</div>
